__turbopack_context__.v({
  "contributorsList": "contributors-list-module__KAqvPW__contributorsList",
  "links": "contributors-list-module__KAqvPW__links",
  "loadMore": "contributors-list-module__KAqvPW__loadMore",
  "name": "contributors-list-module__KAqvPW__name",
});
